import { Injectable, inject } from '@angular/core';
import { EntityState, Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { PaymentSourceAccount, PaymentSourceState } from '@models/account/model';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs';

import { PaymentSourceAccountStore } from './payment-source-account.store';

export type PaymentSourceAccountState = EntityState<PaymentSourceAccount, string>;

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: 'created',
  sortByOrder: Order.DESC,
})
export class PaymentSourceAccountQuery extends QueryEntity<PaymentSourceAccountState> {
  protected store: PaymentSourceAccountStore;

  constructor() {
    const store = inject(PaymentSourceAccountStore);

    super(store);

    this.store = store;
  }

  public selectAllWhenLoaded(): Observable<PaymentSourceAccount[]> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectAll())
    );
  }

  public selectAllActiveWhenLoaded(): Observable<PaymentSourceAccount[]> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() =>
        this.selectAll({
          filterBy: (paymentSourceAccount) => paymentSourceAccount.currentState === PaymentSourceState.Active,
        })
      )
    );
  }

  public selectEntityWhenLoaded(paymentSourceAccountId: string): Observable<PaymentSourceAccount> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectEntity(paymentSourceAccountId))
    );
  }

  public selectByPaymentAccount(paymentAccountId: string): Observable<PaymentSourceAccount> {
    return this.selectAllWhenLoaded().pipe(map((accounts) => accounts.find((account) => account.paymentAccountId === paymentAccountId)));
  }
}
